export default __webpack_public_path__ + "static/media/line-separator.514c0b12.svg";